module.exports = "/src/views/player/help/images/airdrop2.jpg";